
import { defineComponent, ref } from "vue";
import { Search } from "@element-plus/icons-vue";
import { brandList, brandUpdatePush, addBrand, brandUpdate } from "../../../api/Brand";
import { ElMessage } from "element-plus";
import { FormInstance } from "element-plus/lib/components";
import moment from "moment";

export default defineComponent({
  name: "brand",
  setup() {
    const ruleFormRef = ref<FormInstance>();
    const btnLoading = ref(false);
    const tabsType = (type: string | number) => {
      console.log(type);
    };
    const DialogTitle = ref<string>("");
    // from 开关
    const FromDisplay = ref<boolean>(false);
    const FromData = ref();
    // 编辑品牌
    const myclick = (row: any) => {
      FromData.value = {
        name: row.name,
        mobileLogo: row.mobileLogo,
        brandNo: row.brandNo,
        id: row.id,
      };
      FromDisplay.value = true;
      DialogTitle.value = "编辑品牌";
    };
    // 新增品牌
    const addClass = () => {
      FromData.value = {};
      btnLoading.value = false;
      FromDisplay.value = true;
      DialogTitle.value = "新增品牌";
    };
    // 推送开关
    const pushDisplay = ref<boolean>(false);
    const isPush = ref();
    const switchFn = (row: any) => {
      isPush.value = row.isPush;
      pushDisplay.value = true;
      rowId.value = row.id;
    };
    // 表格数据
    const tableData = ref([]);
    const tableColumn = ref([
      {
        prop: "name",
        label: "品牌名称",
      },

      {
        slotName: "classImg",
      },

      {
        slotName: "accounttype",
      },
      {
        prop: "createTime",
        label: "添加时间",
      },
      {
        slotName: "slotName",
      },
    ]);
    const modelrules = ref({
      name: [
        { required: true, message: "请输入名称（限制15字内）", trigger: "blur" },
        { min: 1, max: 15, message: "长度限15字内", trigger: "blur" },
      ],
      mobileLogo: [{ required: true, message: "请上传品牌logo", trigger: "blur" }],
    });
    const srcList = [
      "https://fuss10.elemecdn.com/a/3f/3302e58f9a181d2509f3dc0fa68b0jpeg.jpeg",
      "https://fuss10.elemecdn.com/1/34/19aa98b1fcb2781c4fba33d850549jpeg.jpeg",
      "https://fuss10.elemecdn.com/0/6f/e35ff375812e6b0020b6b4e8f9583jpeg.jpeg",
      "https://fuss10.elemecdn.com/9/bb/e27858e973f5d7d3904835f46abbdjpeg.jpeg",
      "https://fuss10.elemecdn.com/d/e6/c4d93a3805b3ce3f323f7974e6f78jpeg.jpeg",
      "https://fuss10.elemecdn.com/3/28/bbf893f792f03a54408b3b7a7ebf0jpeg.jpeg",
      "https://fuss10.elemecdn.com/2/11/6535bcfb26e4c79b48ddde44f4b6fjpeg.jpeg",
    ];
    const imgViewerVisible = ref(false);
    // 图片预览
    const imgurl = ref<string>("");
    const changeImg = (url: string) => {
      imgurl.value = url;
      imgViewerVisible.value = true;
    };
    const imageUrl = ref("");
    const page = ref({
      pageNum: 1,
      pageSize: 10,
      total: 0,
    });
    const brandName = ref();
    const isLoading = ref(false);
    const rowId = ref(false);
    const searchForm = () => {
      handleCurrentChange(1);
    };
    const handleCurrentChange = (val: any) => {
      if (val) {
        page.value.pageNum = val;
      }
      const baseRequest = {
        name: brandName.value || "",
        baseDto: {
          pageNum: page.value.pageNum,
          pageSize: page.value.pageSize,
        },
      };
      isLoading.value = true;
      brandList(baseRequest).then((res) => {
        if (res.code === 1) {
          res.data.data.forEach((item: any) => {
            item.createTime = moment(item.createTime).format("YYYY-MM-DD HH:mm:ss");
          });
          tableData.value = res.data.data;
          page.value.total = res.data.total;
          page.value.pageNum = res.data.pageNum;
          isLoading.value = false;
        }
      });
    };
    handleCurrentChange(1);
    const handleSizeChange = (num: any) => {
      page.value.pageSize = num;
      handleCurrentChange(1);
    };
    const handleClose = () => {
      handleCurrentChange(page.value.pageNum);
    };
    const isPushSuccess = () => {
      console.log(rowId.value);

      brandUpdatePush(rowId.value).then((res) => {
        if (res.code == 1) {
          ElMessage({
            message: (res.msg as string) || "操作成功",
            type: "success",
          });
        }
        pushDisplay.value = false;
      });
    };
    const uploadChangeImg = (val: any) => {
      console.log(val);
      FromData.value.mobileLogo = val.fileUrl;
    };
    const submitForm = async (formEl: FormInstance | undefined) => {
      console.log(formEl);

      if (!formEl) return;
      await formEl.validate((valid: any, fields: any) => {
        if (valid) {
          btnLoading.value = true;

          if (DialogTitle.value == "新增品牌") {
            let params = {
              name: FromData.value.name,
              mobileLogo: FromData.value.mobileLogo,
            };
            addBrand(params).then((res) => {
              if (res.code === 1) {
                console.log(res);
                ElMessage({
                  message: "操作成功",
                  type: "success",
                });
              }
              FromDisplay.value = false;
              btnLoading.value = false;
            });
          } else {
            let params = {
              name: FromData.value.name,
              mobileLogo: FromData.value.mobileLogo,
              brandNo: FromData.value.brandNo,
              id: FromData.value.id,
            };
            brandUpdate(params).then((res) => {
              if (res.code === 1) {
                console.log(res);
                ElMessage({
                  message: "操作成功",
                  type: "success",
                });
              }
              FromDisplay.value = false;
              btnLoading.value = false;
            });
          }
        } else {
          console.log("error submit!", fields);
        }
      });
    };
    const delectImg = (val: string) => {
      FromData.value.mobileLogo = val;
    };
    return {
      delectImg,
      brandName,
      isLoading,
      btnLoading,
      page,
      handleCurrentChange,
      handleSizeChange,
      tabsType,
      tableData,
      tableColumn,
      myclick,
      srcList,
      changeImg,
      imgurl,
      imgViewerVisible,
      FromDisplay,
      imageUrl,
      addClass,
      FromData,
      pushDisplay,
      switchFn,
      DialogTitle,
      ruleFormRef,
      Search,
      isPush,
      handleClose,
      isPushSuccess,
      searchForm,
      modelrules,
      submitForm,
      uploadChangeImg,
    };
  },
});
